import { Router } from '@angular/router';
import { BasePage } from './../base.page';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoadingController, Platform, ToastController } from '@ionic/angular';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'shc-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage extends BasePage implements OnInit {
  form: UntypedFormGroup;

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
  }

  password = new UntypedFormControl(null,
    Validators.compose([Validators.required, Validators.minLength(8)])
  );

  passwordConfirmation = new UntypedFormControl(null, (control: AbstractControl) => {
    if (this.password.valid && control.value !== this.password.value) {
      return { confirmed: true };
    }
    return null;
  });

  ngOnInit() {
    this.form = new UntypedFormGroup({
      old_password: new UntypedFormControl(null, [
        Validators.required
      ]),
      password: this.password,
      password_confirmation: this.passwordConfirmation,
    });
  }

  changepPassword(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }
    this.userService.updatePassword(this.form.value).subscribe(res => {
      this.router.navigate(['/tabs']);
    }, error => {
      this.errorService.handle(error);
    });
  }

}
